module.exports = __webpack_public_path__ + "img/fi-rr-angle-up.cf95f72c.svg";